import React from 'react'
import { graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { vc_base, vc_color } from '../assets/js/Brand'
import { media } from '../assets/js/Helper'

// components
import Heading from '../components/atoms/BaseHeading'
import Breadcrumb from '../components/molecules/Breadcrumb'
import ListItem from '../components/molecules/ListItem'
import Layout from '../components/templates/Default'

// template
const roleOne = (props) => {
  // 現在の権限の情報取得
  const thisRole = props.data.markdownRemark
  // すべてのファイル取得
  const allItem = props.data.allMarkdownRemark
  // すべての大カテゴリー取得
  const allCatOne = allItem.edges.filter(
    (cat) => cat.node.frontmatter.posttype === 'catOne'
  )
  // 取得したファイルから現在の権限の記事を抜き出す
  const allPost = allItem.edges.filter(
    (post) =>
      post.node.frontmatter.posttype === 'post' &&
      post.node.frontmatter[thisRole.frontmatter.cat] !== '×'
  )
  // 現在の権限で可能な記事の取得
  const totalCount = allPost.length
  // slugを取得して加工する関数
  const processingSlug = (slug) => slug.split('/').filter((e) => e !== '')

  return (
    <Layout>
      <Helmet>
        <html lang="ja" />
        <meta charSet="utf-8" />
        <meta http-equiv="Pragma" content="no-cache" />
        <meta http-equiv="Cache-Control" content="no-cache" />
        <meta http-equiv="Expires" content="0" />
        <title>
          「{thisRole.frontmatter.title}」が対象となるカテゴリー｜ヘルプ
        </title>
      </Helmet>

      <Breadcrumb />

      <Heading level={1} className="title-page">
        「{thisRole.frontmatter.title}」が対象となるカテゴリー
        <TotalCount>（全{totalCount}件）</TotalCount>
      </Heading>

      <PageList>
        <ul>
          {allCatOne.map(({ node }) => {
            // 現在のループしている大カテゴリーに属している記事を抜き出す
            let catOneAllPost = allPost.filter((post) => {
              return (
                processingSlug(node.fields.slug)[0] ===
                processingSlug(post.node.fields.slug)[0]
              )
            })

            // 取得した記事数の取得
            let listCount = catOneAllPost.length
            if (listCount) {
              return (
                <ListItem
                  key={node.id}
                  link={`/roles/${thisRole.frontmatter.cat}/${node.frontmatter.cat}/`}
                >
                  <Heading level={2} className="title-section">
                    {node.frontmatter.title}
                    <TotalCount>（全{listCount}件）</TotalCount>
                  </Heading>
                </ListItem>
              )
            } else {
              return (
                <PageListNoItem key={node.id}>
                  <Heading level={2} className="title-section">
                    {node.frontmatter.title}
                    <TotalCount>（全{listCount}件）</TotalCount>
                  </Heading>
                </PageListNoItem>
              )
            }
          })}
        </ul>
      </PageList>
    </Layout>
  )
}

export default roleOne

// script
export const pageQuery = graphql`
  query($slug: String) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        kind
        posttype
        cat
        order
        title
        date
      }
    }
    allMarkdownRemark(
      sort: { fields: frontmatter___order, order: ASC }
      filter: { frontmatter: { kind: { eq: "faq" } } }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            kind
            posttype
            cat
            order
            title
            date
            owner
            subowner
            manager
            user
            nyuko
          }
          fields {
            slug
          }
        }
      }
    }
  }
`

// style
const TotalCount = styled.span`
  font-size: 65%;
  font-weight: normal;
`
const PageList = styled.div`
  border: 1px solid ${vc_color.border};
  border-radius: ${vc_base.pixel`0.5`};
  margin-top: ${vc_base.pixel};
`
const PageListNoItem = styled.li`
  border-top: 1px solid ${vc_color.border};
  display: flex;
  flex-wrap: wrap;
  padding-bottom: ${vc_base.pixel`1.5`};
  padding-left: ${vc_base.pixel`1.5`};
  padding-right: ${vc_base.pixel`1.5`};
  padding-top: ${vc_base.pixel`1.5`};
  ${media.Large`
		flex-wrap: nowrap;
		padding-top: ${vc_base.pixel`2.5`};
		padding-bottom: ${vc_base.pixel`2.5`};
		padding-left: ${vc_base.pixel`2.5`};
		padding-right: ${vc_base.pixel`2.5`};
	`}
  &:first-child {
    border-top: none;
  }
`
